import moment from 'moment';
import store from '../store/index.js';
import i18n, { IDIOMA_PADRAO } from '@/i18n';

/** "18:00 - 23:00" -> { inicio: 1080, fim: 1380 }, em minutos desde a meia-noite. */
const parseFaixa = texto => {
    const partes = /^\s*([01]\d|2[0-3]):([0-5]\d)\s*-\s*([01]\d|2[0-3]):([0-5]\d)\s*$/.exec(texto || '');

    if (!partes) {
        return null;
    }

    return {
        inicio: Number(partes[1]) * 60 + Number(partes[2]),
        fim: Number(partes[3]) * 60 + Number(partes[4]),
    };
};

// Em português, 24h como sempre ("23:00"); nos outros idiomas, o formato do moment no idioma ("11:00 PM").
const hhmm = minutos => {
    if (i18n.locale !== IDIOMA_PADRAO) {
        return moment().startOf('day').add(minutos, 'minutes').format('LT');
    }

    const hora = String(Math.floor(minutos / 60)).padStart(2, '0');
    const minuto = String(minutos % 60).padStart(2, '0');

    return `${hora}:${minuto}`;
};

const fechado = text => ({ text, color: 'error', status: false });
const aberto = text => ({ text, color: 'success', status: true });

export const isOpen = () => {
    const config = store.state.configuracoes;

    const agora = moment(store.state.relogio);

    if (!config.ativo) {
        return fechado(i18n.t('horario.fechado'));
    }

    const hoje = config.horarios?.find(f => f.isoWeekday == agora.isoWeekday());

    if (!hoje) {
        return fechado(i18n.t('horario.fechado'));
    }

    if (!hoje.aberto) {
        return fechado(i18n.t('horario.fechadoHoje'));
    }

    const faixas = [
        parseFaixa(hoje.horario),
        hoje.segundoHorarioAtivo ? parseFaixa(hoje.segundoHorario) : null,
    ].filter(Boolean).sort((a, b) => a.inicio - b.inicio);

    if (!faixas.length) {
        return fechado(i18n.t('horario.fechado'));
    }

    const minutos = agora.hours() * 60 + agora.minutes();

    const emAtendimento = faixas.find(f => minutos >= f.inicio && minutos <= f.fim);
    if (emAtendimento) {
        return aberto(i18n.t('horario.abertoAte', { hora: hhmm(emAtendimento.fim) }));
    }

    const proxima = faixas.find(f => minutos < f.inicio);
    if (proxima) {
        return fechado(i18n.t('horario.fechadoAbre', { hora: hhmm(proxima.inicio) }));
    }

    return fechado(i18n.t('horario.fechado'));
};

export const requireScheduling = () => {
    const config = store.state.configuracoes;

    const open = isOpen();

    if (!config.agendamento?.ativo) {
        return false;
    }

    return config.agendamento?.obrigatorio || !open.status;
}
